import { InfoCircleOutlined } from "@ant-design/icons";
import { Card, Col, Row, Skeleton, Typography } from "antd";
import axios from "axios";
import CompanyLogo from "components/CompanyLogo/CompanyLogo";
import { Company } from "interfaces/company";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

const { Title, Text } = Typography;

const KarriereKveldenBox = () => {
  const [company, setCompany] = useState<Company>();

  useEffect(function getCompany() {
    axios.get(`/companies/2476/`).then(response => setCompany(response.data));
  }, []);

  const history = useHistory();

  const openEvent = () => {
    return history.push(`/kd/karrierekvelden/`);
  };

  return (
    <Col key="karrierekvelden" style={{ marginBottom: "1em" }}>
      <Card hoverable onClick={openEvent} bodyStyle={{ padding: "0.5em", paddingLeft: "0.8em" }}>
        <Row>
          <Col span={4}>
            {company ? <CompanyLogo size="100%" companyId={2476} src={company.logo} /> : <Skeleton.Image />}
          </Col>
          <Col
            span={17}
            style={{ paddingLeft: "1em", lineHeight: "100%", paddingTop: "0.5em", paddingBottom: "0.5em" }}
          >
            <Row>
              <p style={{ color: "gray" }}>Trykk her for å lese mer om KarriereKvelden</p>
            </Row>
            <Row>
              <Title level={4}>KarriereKvelden</Title>
            </Row>
            <Row>
              <InfoCircleOutlined style={{ marginRight: "0.4em" }} />
              <Text>En eksklusiv avslutning på KarriereDagene med middag og underholdning.</Text>
            </Row>
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

export default KarriereKveldenBox;
